import React, { useMemo } from "react";
import { createSelectorHooks } from "auto-zustand-selectors-hook";
import objectPath from "object-path";
import { Link } from "react-router-dom";

import { toAbsoluteUrl } from "@helpers/AssetsHelpers";
import useStoreUserRoles from "@src/app/_storeUserRoles";

// import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";

// import useStoreUserRoles from './../../../../app/_storeUserRoles';


export function Brand() {
  const uiService = useHtmlClassService();
  const _store = createSelectorHooks(useStoreUserRoles);
  const __application = _store.useApplication();
  // const _store = useStoreUserRoles(getState, shallow);

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo()
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Brand */}
      <div
        className={`brand flex-column-auto ${layoutProps.brandClasses}`}
        id="kt_brand"
      >
        {/* begin::Logo */}
        <Link to="" className="brand-logo">
          <img alt="logo" height={50} src={toAbsoluteUrl("/media/logos/archemlogo.png")} style={{ marginLeft: -6 }} />
          <h5 className="text-white font-weight-bolder" style={{ paddingTop: 10, paddingLeft: 10 }}>{(__application || '').toUpperCase()}</h5>
          {/* <img alt="logo" src={layoutProps.headerLogo}/> */}
        </Link>
        {/* end::Logo */}

        {/* "/media/svg/icons/Navigation/Angle-double-left.svg" */}
        {/* layoutProps.asideSelfMinimizeToggle && */}
        {(
          <>
            {/* begin::Toggle */}
            <button className="brand-toggle btn btn-sm px-0" id="kt_aside_toggle_2">
              <span className="svg-icon svg-icon-xl notabsolute brand-archem-logo">
                <img alt="logo" height={50} className="logo-minimized" src={toAbsoluteUrl("/media/logos/archemlogo.png")} />
                {/* <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-double-left.svg")}/> */}
              </span>
            </button>
            {/* end::Toolbar */}
          </>
        )}
      </div>
      {/* end::Brand */}
    </>
  );
}
